import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from 'angularfire2/storage';
import { Observable } from 'rxjs';
import { TextSearch } from '../../../comum/textSearch';
import { base64Encode } from '@firebase/util';
import { AngularFirestore } from 'angularfire2/firestore';


var dbConn:AngularFirestore,
    cmpThis:UploadImgComponent;
    
function setAngularInstance(db:AngularFirestore, comp){
  dbConn = db;
  cmpThis = comp;
}

function saveFile(nome,base64){
  dbConn.collection('imagens').doc(nome).set(base64,{merge:true});
}


@Component({
    selector: 'upload-img',
    template: `
     <div fxFlex fxLayout="row" fxLayoutGap="5px"> 
      <input mat-button type="file" (change)="uploadFile($event)" />{{ percent }}
      </div>
   `
  })
  export class UploadImgComponent {
    uploadPercent: Observable<number>;
    percent:number;
    fileName:string = "";

    @Input()
    filePath = "/img";
  
    @Input()
    subPath:string = "";

    @Output()
    changePath = new EventEmitter<string>() ;

    @Output()
    dataPath = new EventEmitter<string>();

    @Input()
    saveAs:string;


    downloadURL: Observable<string>;
    constructor(private db:AngularFirestore, private storage: AngularFireStorage) {}
    uploadFile(event) {
      setAngularInstance(this.db,this);
      const file = event.target.files[0];
      this.fileName =  TextSearch.retirarAcentos(file.name).replace(' ','')
      
      var reader = new FileReader();
      var fname = this.fileName;
      reader.onloadend = function(e){
        var b = {src:reader.result}
        saveFile(fname, b);
      
      }
      reader.readAsDataURL(file);

      let p = this.filePath+this.subPath+'/'+this.fileName;
      if (this.saveAs)
        p = this.saveAs;
      const taskUp:AngularFireUploadTask = this.storage.upload(p, file);
      // observe percentage changes
      this.uploadPercent = taskUp.percentageChanges() ;
      this.uploadPercent.subscribe( m=>{
        this.percent = Math.round( m );
       if (this.percent>=100) {
         this.changePath.emit(p);
         this.dataPath.emit(fname);
       }
      });
      taskUp.snapshotChanges().subscribe(
          r=>{
          }
      )
      // get notified when the download URL is available
      //this.downloadURL =  taskUp.downloadURL();
    }
  }